import { last } from "lodash";

// eslint-disable-next-line import/prefer-default-export
export const isLastBreadcrumbLink = (breadcrumbGroupId, group) =>
  last(group.hierarchyIds) === breadcrumbGroupId;
